<template>
  <div class="container">
    <h2>{{ t('info.title') }}</h2>

    <div class="info-content">
      <section class="info-card card">
        <h3>{{ t('info.about') }}</h3>
        <p>{{ t('info.aboutText') }}</p>
      </section>

      <section class="info-card card">
        <h3>{{ t('info.version') }}</h3>
        <p class="version">{{ version }}</p>
      </section>

      <section class="info-card card">
        <h3>{{ t('info.language') }}</h3>
        <div class="language-selector">
          <button
            v-for="lang in languages"
            :key="lang.code"
            :class="['btn', currentLanguage === lang.code ? 'btn-primary' : 'btn-secondary']"
            @click="changeLanguage(lang.code)"
          >
            {{ lang.name }}
          </button>
        </div>
      </section>

      <section class="info-card card">
        <h3>{{ t('info.credits.title') }}</h3>
        <p>{{ t('info.credits.game') }}</p>
        <p class="credit-text">{{ t('info.credits.design') }}</p>
      </section>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { setLanguage, getCurrentLanguage } from '../i18n';

const { t } = useI18n();

const version = __APP_VERSION__;

const languages = [
  { code: 'de', name: 'Deutsch' },
  { code: 'en', name: 'English' },
];

const currentLanguage = computed(() => getCurrentLanguage());

function changeLanguage(locale: string): void {
  setLanguage(locale);
}
</script>

<style scoped>
.info-content {
  max-width: 600px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-lg);
}

.info-card h3 {
  color: var(--color-accent-gold);
  margin-bottom: var(--spacing-md);
  font-size: 1.25rem;
}

.info-card p {
  color: var(--color-text-secondary);
  line-height: 1.6;
  margin-bottom: var(--spacing-sm);
}

.version {
  font-size: 1.5rem;
  color: var(--color-accent-gold);
  font-weight: 600;
}

.language-selector {
  display: flex;
  gap: var(--spacing-md);
}

.language-selector .btn {
  flex: 1;
}

.credit-text {
  font-size: 0.875rem;
  color: var(--color-text-muted);
}
</style>
